var render = function render(){var _vm=this,_c=_vm._self._c;return _c('custom-dropdown',{key:_vm.dropdownKey,attrs:{"list":_vm.normalizedList,"selected":_vm.selectedOption,"default-label":'content...',"default-style":_vm.defaultStyle,"prevent-deselection":""},on:{"select":_vm.selectItem}})
}
var staticRenderFns = []

export { render, staticRenderFns }